"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FACTOR_WHITELIST = exports.FactorType = void 0;
var FactorType;
/**
 * This type is derived from the `generic_log_emission_factors` table. We are excluding the `Emission` portion
 * of the name since it is a misnomer. This type has no specific relationship with emissions
 */

exports.FactorType = FactorType;

(function (FactorType) {
  FactorType["CONSTANT"] = "Constant";
  FactorType["FACTOR"] = "Factor";
  FactorType["OTHER"] = "Other";
})(FactorType || (exports.FactorType = FactorType = {}));

var FACTOR_WHITELIST = ['groupId', 'readonly', 'itemType', 'itemValue', 'logId', 'logProjectId', 'name', 'notes', 'projectId', 'units', 'versionSyncStartedAt', 'versionSyncCompletedAt'];
exports.FACTOR_WHITELIST = FACTOR_WHITELIST;